import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { styled } from '@mui/system';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { Link, useNavigate } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { logout } from '../../actions/auth-actions';
import { LOGIN_URL } from '../../utils/redirect-const';

const Badge = styled('span')(({ theme }) => ({
  height: '14px',
  letterSpacing: '1px',
  color: 'black',
  border: '1px solid #fda4af',
  margin: '0 4px',
  padding: '.25em',
  fontSize: 12,
  fontWeight: '600',
  position: 'absolute',
  textAlign: 'center',
  borderRadius: '.25rem',
  transition: 'color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out',
}));

const StyledAppBar = styled(AppBar)({
  backgroundColor: 'white',
  boxShadow: 'none',
  borderBottom: '1px solid',
  borderColor: '#e5e7eb'
});

const StyledButton = styled(Button)({
  backgroundColor: '#fda4af',
  color: 'white',
  '&:hover': {
    backgroundColor: '#fb7185',
  },
  boxShadow: 'none !important',
  marginLeft: '16px',
  padding: '4px !important',
  letterSpacing: '1.2px'
});

const MenuItemsSection = styled('div')(({ theme }) => ({
  gap: '16px',
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));

const MobileMenuSection = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.up('sm')]: {
    display: 'none',
  },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  paddingLeft: 0,
  paddingRight: 0,
  [theme.breakpoints.up('sm')]: {
    paddingLeft: 0,
    paddingRight: 0,
  },
}));

const MenuItems = ({ isAuthenticated }) => (
  <>
    {!isAuthenticated && (
      <StyledButton component={Link} to={LOGIN_URL} variant="contained">
        Zaloguj się
      </StyledButton>
    )}
  </>
);

const AccountMenu = ({ anchorEl, open, handleClose, handleLogout }) => {
  const navigate = useNavigate();

  const handleMenuItemClick = (path) => {
    handleClose();
    navigate(path);
  };

  return (
    <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
      <MenuItem onClick={() => handleMenuItemClick('/ustawienia')}>Ustawienia</MenuItem>
      <MenuItem onClick={() => {
        handleClose();
        handleLogout();
      }}>Wyloguj</MenuItem>
    </Menu>
  );
};

const Header = () => {
  const [accountMenuAnchorEl, setAccountMenuAnchorEl] = useState(null);
  const isAuthenticated = useSelector((state) => state.auth.authenticated);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logout());
  };

  const handleAccountMenuOpen = (event) => {
    setAccountMenuAnchorEl(event.currentTarget);
  };

  const handleAccountMenuClose = () => {
    setAccountMenuAnchorEl(null);
  };

  const handleLogoClick = () => {
    if (isAuthenticated) {
      navigate('/encyklopedia');
    } else {
      navigate('/');
    }
  };

  return (
    <>
      <StyledAppBar position="static">
        <Container maxWidth="lg" sx={{ paddingLeft: '8px', paddingRight: '8px' }}>
          <StyledToolbar>
            <Grid container spacing={1} alignItems="center" justifyContent="space-between">
              <Grid item>
                <Typography variant="h4" sx={{ color: '#fda4af', cursor: 'pointer' }} onClick={handleLogoClick}>
                  Dieta Niemowlaka
                  <Badge>BETA</Badge>
                </Typography>
              </Grid>
{/*                <Grid item> */}
{/*                       <StyledButton component={Link} to="/newsletter" variant="contained"> */}
{/*                            Newsletter */}
{/*                          </StyledButton> */}
{/*                    </Grid> */}
              <Grid item>
                <MenuItemsSection>
                  <MenuItems isAuthenticated={isAuthenticated} />
                  {isAuthenticated && (
                    <IconButton
                      color="inherit"
                      onClick={handleAccountMenuOpen}
                      sx={{ ml: 1 }}
                    >
                      <AccountCircleIcon  />
                    </IconButton>
                  )}
                  <AccountMenu
                    anchorEl={accountMenuAnchorEl}
                    open={Boolean(accountMenuAnchorEl)}
                    handleClose={handleAccountMenuClose}
                    handleLogout={handleLogout}
                  />
                </MenuItemsSection>
                <MobileMenuSection>
                  <MenuItems isAuthenticated={isAuthenticated} />
                  {isAuthenticated && (
                    <IconButton
                      color="inherit"
                      onClick={handleAccountMenuOpen}
                      sx={{ ml: 1 }}
                    >
                      <AccountCircleIcon />
                    </IconButton>
                  )}
                </MobileMenuSection>
              </Grid>
            </Grid>
          </StyledToolbar>
        </Container>
      </StyledAppBar>
    </>
  );
};

export default Header;